module.exports = __webpack_public_path__ + "img/star.e96e30b6.svg";